import React, { memo } from 'react';

export interface IFeatureGuardProps {
  featuresMap: any;
  featureKey: any;
  children: React.ReactElement;
  fallback?: React.ReactElement;
}

const FeatureGuard = ({ featuresMap, featureKey, fallback = null, children }: IFeatureGuardProps) => {
  return featuresMap[featureKey] ? children : fallback;
};

export default memo(FeatureGuard);
